
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { Worker } from 'app/_models/worker.model';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { SiteOwnerUserService } from 'app/_services/site-owner-user.service';
import { SiteWorkersService } from 'app/_services/site-workers.service';
import { SiteService } from 'app/_services/site.service';
import { TabItemHelperService } from 'app/_services/tab-item-helper.service';
import { environment } from 'environments/environment';
import { ContextMenu } from 'primeng/contextmenu';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { EditWorkerSiteModalComponent } from './components/edit-worker-site-modal/edit-worker-site-modal.component';
import { MultiEditChooseSiteTypeModalComponent } from './components/multi-edit-choose-site-type-modal/multi-edit-choose-site-type-modal.component';
import { ResendInductionReminderModalComponent } from 'app/shared-pages/site-pages/site-workers/resend-induction-reminder-modal/resend-induction-reminder-modal.component';

@Component({
  selector: 'user-site-details',
  templateUrl: './user-site-details.component.html'
})
export class UserSiteDetailsComponent implements OnInit {
  public role: any;
  public routeRole: any;
  public tabitems = [];
  public backLink: string;
  public worker: Worker;
  private siteOwnerId: any;
  private selectedWorkerId: any;
  public selectedWorker: any;
  public isAdmin: boolean;
  public id = 10
  sites: any = [];
  public TrainingCourseStateType = TrainingCourseState; // allow enum in template
  groupedSites: {};
  rowGroupMetadata: {} = {};

  public tickedBoxes: number[] = [];
  contextMenuItems: { label: string; icon: string; command: (event: any) => any; }[];
  private selectedSiteByMenuBox: any;
  private canEditDelegate: boolean;
  private siteOwnerIds: number[] = [];

  public selectedSiteOwnerId = null;
  public siteOwners = [];
  public selectedSiteOwner;
  public filteredSites = [];
  public uniqueSiteOwnerCount: number;
  public isPowerStationRole: boolean;

  constructor(
    private contractorService: ContractorService,
    private siteService: SiteService,
    private notificationService: NotificationService,
    private modalService: NgbModal,
    private tabItemHelperService: TabItemHelperService,
    private siteWorkersService: SiteWorkersService,
    private activatedRoute: ActivatedRoute,
    private siteOwnerUserService: SiteOwnerUserService,
    private globals: Globals,
  ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.isPowerStationRole = this.globals.user.routeRole === 'power-station-owner' || this.globals.user.routeRole === 'power-station-manager';
    this.canEditDelegate = this.globals.user.routeRole !== 'site-delegate' && !this.isPowerStationRole;

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.backLink = params.backLink;
      this.siteOwnerId = params.siteOwnerId ? parseInt(params.siteOwnerId, 10) : null;
    });

    if (this.routeRole === 'admin' || this.routeRole == 'support') {
      this.isAdmin = true;
      this.activatedRoute.params.subscribe((params: Params) => {
        this.selectedWorkerId = parseInt(params.userId);
        this.tabitems = this.tabItemHelperService.getWorkerSectionTabItems(this.routeRole, this.backLink, this.selectedWorkerId, this.siteOwnerId);
      });
    } else {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.selectedWorkerId = parseInt(params.userId);
        this.tabitems = this.tabItemHelperService.getWorkerSectionTabItems(this.routeRole, this.backLink, this.selectedWorkerId, this.siteOwnerId);
      });
    }
  }

  ngOnInit() {
    this.getSelectedWorkerAndCompetencies(this.selectedWorkerId);

    if (this.isAdmin) {
      this.getSiteOwnersList();
    }
    this.getSiteData();

    this.setUpContextMenu();
  }

  public getSelectedWorkerAndCompetencies(id) {
    this.contractorService.getWorkerById(id).subscribe((data: any) => {
      this.selectedWorker = data;
    });
  }

  public onSelectedSiteOwnerChange(event) {
    this.tickedBoxes = [];
    this.siteOwnerId = event.value;
    this.selectedSiteOwnerId = event.value;
    this.filterSites();
  }

  private getSiteOwnersList() {
    this.siteOwnerUserService.getAllEnabledSiteOwnersForDropdowns().subscribe((result: any) => {
      this.siteOwners = [
        { label: 'All', value: null },
        ...result.map(item => ({
        label: item.firstName + ' ' + item.lastName,
        value: item.id
      }))];
    });
  }

  private getSiteData() {
    forkJoin([
      this.siteService.getAllSitesNoPagination(),
      this.contractorService.getSitesByWorkerId(this.selectedWorkerId)
    ]).subscribe(([data1, data2]: [any, any]) => {
      this.sites = (data1 as any); // all sites current user has access to
      const workerSites = data2; // all sites for the worker selected

      this.sites = this.sites.map(site => {
        const workerSite = workerSites.find(workerSite => site.id === workerSite.site.id);
        if (workerSite) {
          return {
            ...site,
            onSite: true,
            workerSiteId: workerSite.id,
            assetCategories: workerSite.assetCategories.sort((a, b) => a.name.localeCompare(b.name)),
            inductionForSite: workerSite.inductionForSite,
            managementDuty: workerSite.managementDuty,
            guestsPermitted: workerSite.guestsPermitted,
            siteDelegate: workerSite.siteDelegate,
            isSendingInductionReminder: false,
            inductionReminderSent: false,
          };
        }
        return site;

      });

      this.uniqueSiteOwnerCount = this.countUniqueSiteOwnerIds(this.sites);

      this.sites.sort((a, b) => {
        return a.siteType.id - b.siteType.id;
      });

      this.filterSites();
    });
  }

  private filterSites() {
    // reset all by cloning non-filtered list
    this.filteredSites = [...this.sites];

    if (this.selectedSiteOwnerId) {
      this.filteredSites = this.filteredSites.filter(site => {
        return (site.siteOwner.id === this.selectedSiteOwnerId);
      });
    }

    this.updateRowGroupMetaData();
  }

  // used to group the table under subheadings
  private updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.filteredSites) {
      let previousSiteTypeId = null;
      this.filteredSites.forEach((site, i) => {
        const siteTypeId = site.siteType.id;
        if (siteTypeId !== previousSiteTypeId) {
          this.rowGroupMetadata[siteTypeId] = { index: i, size: 1 };
          previousSiteTypeId = siteTypeId;
        } else {
          this.rowGroupMetadata[siteTypeId].size++;
        }
      });
    }
  }

  private setUpContextMenu() {
    this.contextMenuItems = [
      { label: 'Add/Edit', icon: 'pi pi-fw pi-plus', command: () => this.openEditModal() },
      { label: 'Remove', icon: 'pi pi-fw pi-times', command: () => this.onDeleteFromSite() },
      ...(!this.isPowerStationRole ? [ { label: 'Copy Settings', icon: 'pi pi-fw pi-copy', command: () => this.copyOptions() } ] : []),
      ...(this.canEditDelegate ? [ { label: 'Delegate Status', icon: 'pi pi-fw pi-star', command: () => this.toggleDelegateStatus() } ] : []),
    ];
  }

  public async openEditModal() {
    try {
      const siteTypeId = await this.checkForOverlappingSiteTypes();
      const selectedSites = this.getSelectedSites().filter(s => s.siteType.id === siteTypeId);

      this.openModalComponent(EditWorkerSiteModalComponent, 'md', {
        siteTypeId: siteTypeId,
        sites: selectedSites,
        skylarkUserId: this.selectedWorkerId
      });
    } catch (error) {
      // cancelled
    }
  }

  // returns the single site type, or opens a modal to let the user choose one site type
  public checkForOverlappingSiteTypes() {
    return new Promise((resolve, reject) => {
      const selectedSites = this.getSelectedSites();

      const siteTypes = this.getUniqueSiteTypes(selectedSites);
      const numberOfSiteTypes = siteTypes.length;

      if (numberOfSiteTypes === 1) {
        return resolve(selectedSites[0].siteType.id);
      } else {
        const modal = this.modalService.open(MultiEditChooseSiteTypeModalComponent);
        modal.componentInstance.siteTypes = siteTypes;

        modal.result.then(result => {
          return resolve(result);
        }).catch(() => {
          /* modal dismissed */
          return reject();
      });
      }
    });
  }

  private getUniqueSiteTypes(sites) {
    const uniqueSiteTypes = [];
    const siteTypeIds = new Set();

    sites.forEach(site => {
      if (!siteTypeIds.has(site.siteType.id)) {
        uniqueSiteTypes.push(site.siteType);
        siteTypeIds.add(site.siteType.id);
      }
    });

    return uniqueSiteTypes;
  }

  private countUniqueSiteOwnerIds(sites: any[]): number {
    const uniqueSiteOwnerIds = new Set<number>();

    sites.forEach(site => {
      uniqueSiteOwnerIds.add(site.siteOwner.id);
    });

    return uniqueSiteOwnerIds.size;
  }

  private openModalComponent(modalComponent: any, modalWidth: 'sm' | 'md' | 'lg', options?) {
    const modalOptions: NgbModalOptions = { centered: true };
    if (modalWidth === 'sm' || modalWidth === 'lg') {
      modalOptions.size = modalWidth;
    }

    const modal = this.modalService.open(modalComponent, modalOptions);
    Object.keys(options).forEach(option => {
      modal.componentInstance[option] = options[option];
    })

    modal.result.then(result => {
      if (result === 'refresh') {
        this.getSiteData();
      }
    }).catch(() => { /* modal dismissed */ });
  }

  public onDeleteFromSite() {
    const editSites = this.getSelectedSites().filter(s => s.onSite);

    if (editSites.length < 1) {
      this.notificationService.notify('warning', 'No valid site', 'Worker is not on the selected site(s)');

      return;
    }

    Swal.fire({
      title: `Remove Worker from ${editSites.length} Site${editSites.length === 1 ? '' : 's' }?`,
      text: 'This will prevent the worker from accessing the site',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, remove',
    }).then((result) => {
      if (result.value) {
        let requests = [];

        for (let i = 0; i < editSites.length; i++) {
          const site = editSites[i];
          requests.push(this.siteWorkersService.removeWorkerFromSite(site.workerSiteId));
        }

        forkJoin(requests).subscribe(() => {
          this.getSiteData();
          this.notificationService.notify('success', 'Removed', `Worker has been removed from site${editSites.length === 1 ? '' : 's'}`);
        });
      }
    });
  }

  private copyOptions(): any {
    if (!this.selectedSiteByMenuBox.onSite) {
      this.notificationService.notify('warning', 'Nothing to copy');
      return;
    }

    const copyableValues = {
      assetCategories: this.selectedSiteByMenuBox.assetCategories,
      guestsPermitted: this.selectedSiteByMenuBox.guestsPermitted,
      managementDuty: this.selectedSiteByMenuBox.managementDuty,
      siteTypeId: this.selectedSiteByMenuBox.siteType.id,
    }

    localStorage.setItem('ui.clipboard.workerSiteOptions', JSON.stringify(copyableValues));
    this.notificationService.notify('success', 'Copied');
  }

  private toggleDelegateStatus(): any {
    if (!this.canEditDelegate) {
      return;
    }

    const editSites = this.getSelectedSites().filter(s => s.onSite);
    if (editSites.length < 1) {
      this.notificationService.notify('warning', 'No valid site', 'Worker is not on the selected site(s)');
      return;
    }

    if ((editSites.some(s => s.id === environment.HUNTSTOWN_ID))) {
      this.notificationService.notify('warning', 'Selected invalid site', 'Powerstation does not use Site Delegate roles');
      return;
    }

    Swal.fire({
      title: `Add or Remove site delegate status from ${editSites.length} site${editSites.length === 1 ? '' : 's'}`,
      text: 'This grants the worker certain admin rights similar to the Site Owner',
      type: 'info',
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Add Delegate Status',
      cancelButtonText: 'Remove Delegate Status',
    }).then((result) => {
      if (result.value) {
        this.changeAllSiteDelegateStatuses(editSites, true).then(() => {
          this.getSiteData();
          this.notificationService.notify('success', 'Added');
        });

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.changeAllSiteDelegateStatuses(editSites, false).then(() => {
          this.getSiteData();
          this.notificationService.notify('success', 'Removed');
        });
      }
    });
  }

  private changeAllSiteDelegateStatuses(editSites: any[], status: boolean) {
    return new Promise((resolve, reject) => {
      let requests = [];

      for (let i = 0; i < editSites.length; i++) {
        const site = editSites[i];

        const body = {
          siteDelegate: status,
          assetCategoryIds: site.assetCategories.map(item => item.id),
          guestsPermitted: site.guestsPermitted,
          managementDuty: site.managementDuty,
          id: site.workerSiteId,
        };

        requests.push(this.siteWorkersService.editSiteWorker(body));
      }

      forkJoin(requests).subscribe(() => {
        return resolve(true);
      });
    });
  }

  public checkboxChange(checked: boolean, siteId: number) {
    if (checked) {
      this.tickedBoxes.push(siteId);
    } else {
      const index = this.tickedBoxes.indexOf(siteId);
      if (index > -1) {
        this.tickedBoxes.splice(index, 1);
      }
    }
  }

  private getSelectedSites() {
    if (!this.tickedBoxes.length) {
      return [this.selectedSiteByMenuBox];
    }

    return this.sites.filter(s => this.tickedBoxes.includes(s.id)).sort((a, b) => Number(b.onSite) - Number(a.onSite));
  }

  public toggleSelectAll() {
    if (this.filteredSites.length === this.tickedBoxes.length) {
      this.tickedBoxes = [];
    } else {
      this.tickedBoxes = this.filteredSites.map(s => s.id);
    }
  }

  public toggleSelectAllBySiteType(siteTypeId) {
    const sites = this.filteredSites.filter(s => s.siteType.id === siteTypeId);
    const ticks = this.tickedBoxes.filter(t => sites.map(s => s.id).includes(t));

    if (sites.length === ticks.length) {
      this.tickedBoxes = this.tickedBoxes.filter(t => !ticks.includes(t));
    } else {
      this.tickedBoxes = this.tickedBoxes.concat(sites.map(s => s.id).filter(id => !this.tickedBoxes.includes(id)));
    }
  }

  public onLeftMouseClick(event: MouseEvent, contextMenu: ContextMenu, site: any): void {
    this.selectedSiteByMenuBox = site;
    event.stopPropagation();
    event.preventDefault();
    contextMenu.show(event);
  }

  public resendInductionReminder(site: any) {
    if (!site || !site.siteInductionCourse || site.isSendingInductionReminder || site.inductionReminderSent) {
      return;
    }

    const modalRef = this.modalService.open(ResendInductionReminderModalComponent, { centered: true, size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.workerFirstName = this.selectedWorker ? this.selectedWorker.firstName : '';
    modalRef.componentInstance.siteName = site.name;
    modalRef.componentInstance.defaultMessage = `Please complete your induction for ${site.name} BEFORE arriving to site`;
    modalRef.componentInstance.skylarkUserId = this.selectedWorkerId;
    modalRef.componentInstance.courseId = site.siteInductionCourse.id;
    modalRef.componentInstance.workerEmail = this.selectedWorker && this.selectedWorker.email
      ? this.selectedWorker.email
      : 'worker';

    modalRef.componentInstance.sendingStateChange.subscribe((isSending: boolean) => {
      site.isSendingInductionReminder = isSending;
    });

    modalRef.componentInstance.reminderSent.subscribe(() => {
      site.inductionReminderSent = true;
    });
  }
}
